import styled from "styled-components";
import {
  Container, 
  Box,
  AppBar
} from '@material-ui/core';

export const StyledContainer = styled(Container)`
    position: relative;
    max-width: 100% !important;
    padding: 0 !important;
    box-sizing: border-box !important;`


export const StyledAppBar = styled(AppBar)`
    height: 60px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px !important;
    background: #202020 !important;
    box-shadow: none !important;
    display: flex;`


export const StyledBox = styled(Box)`
     min-height: 500px;
    background: #181818;
    box-sizing: border-box !important;
    margin-top: 70px !important;`